import React from "react";
import { SWRConfig } from "swr";

import { APIError } from "../data/api";
import * as Sentry from "@sentry/browser";

interface SWRClientProps {
  children?: React.ReactNode;
}

export function SWRClient(props: SWRClientProps) {
  const { children } = props;

  return (
    <SWRConfig
      value={{
        fetcher: async (input: RequestInfo) => {
          const res = await fetch(input);

          const body = await res.json();

          if (res.status >= 200 && res.status < 300) {
            return body;
          }

          Sentry.withScope((scope) => {
            scope.setExtras(body);

            Sentry.captureMessage(`SWR Error: ${body.message}`, "error");
          });

          throw new APIError(body.message);
        },
      }}
    >
      {children}
    </SWRConfig>
  );
}
